import { AuditoriumTicketScan } from 'components/auditorium/ticketScan'
import { ConfirmButtonLarge } from 'components/button/button.styled'
import { useEffect, useRef } from 'react'
import { EventDetails, SeatSellingModes } from 'types/Event'
import { getSeatLabelForSeatId } from 'utils/seatLabel'

import { Container, ScanMessage, ScanMessageWrapper, TicketDataLabel } from '../ticket.style'

interface Props {
    event: EventDetails
    currentSeatData: any
    success: boolean
    onScanNewTicket: () => void
}

export const CurrentlyScannedTicket = ({ event, currentSeatData, success, onScanNewTicket }: Props) => {
    const successAudioRef = useRef<HTMLAudioElement | null>(null)
    const errorAudioRef = useRef<HTMLAudioElement | null>(null)

    useEffect(() => {
        successAudioRef.current = new Audio('/sounds/success.mp3')
        errorAudioRef.current = new Audio('/sounds/error.mp3')
    }, [])

    useEffect(() => {
        const audio = success ? successAudioRef.current : errorAudioRef.current
        if (audio) {
            audio.currentTime = 0
            audio.volume = 1.0
            audio.play().catch((err) => {
                console.warn('Audio playback blocked:', err)
            })
        }
    }, [success])

    const handleScanNewTicket = () => {
        onScanNewTicket()
    }

    const seatLabel = getSeatLabelForSeatId(event, currentSeatData.scannedSeatId) || 'Ismeretlen hely'

    return (
        <Container>
            {event.seat_selling_mode === SeatSellingModes.SeatBased && (
                <AuditoriumTicketScan
                    rows={currentSeatData.onGallery ? event.location.auditorium.gallery?.rows || null : event.location.auditorium.rows}
                    columns={
                        currentSeatData.onGallery ? event.location.auditorium.gallery?.columns || null : event.location.auditorium.columns
                    }
                    seats={currentSeatData.onGallery ? event.location.auditorium.gallery?.seats || [] : event.location.auditorium.seats}
                    tickets={event.tickets || []}
                    eventId={event.event_id}
                    currentSeatData={currentSeatData}
                    success={success}
                    isGallery={currentSeatData.onGallery}
                    galleryName={currentSeatData.onGallery ? event.location.auditorium.gallery?.gallery_name : undefined}
                />
            )}
            <ScanMessageWrapper>
                <ScanMessage success={success}>
                    {success ? (
                        <>
                            Sikeres jegybeolvasás!
                            <br />
                            {event.seat_selling_mode === SeatSellingModes.SeatBased && seatLabel}
                        </>
                    ) : (
                        <>
                            A jegyet már érvényesítették!
                            <br />
                            {event.seat_selling_mode === SeatSellingModes.SeatBased && seatLabel}
                        </>
                    )}
                </ScanMessage>
                {event.seat_selling_mode === SeatSellingModes.General && (
                    <TicketDataLabel>{`${event.number_of_arrived_tickets}/${event.number_of_sold_tickets} megérkezett`}</TicketDataLabel>
                )}
                <ConfirmButtonLarge onClick={handleScanNewTicket}>Új jegy beolvasása</ConfirmButtonLarge>
            </ScanMessageWrapper>
        </Container>
    )
}
